var map = {
	"./1.png": "Txl5",
	"./1none.png": "TkbQ",
	"./2.png": "UT21",
	"./2none.png": "4T2K",
	"./3.png": "U+2z",
	"./3none.png": "qlA7",
	"./4.png": "8y5t",
	"./4none.png": "ba9w",
	"./5.png": "bj4H",
	"./5none.png": "bm7c",
	"./6.png": "QFQK",
	"./6none.png": "iRb4",
	"./DONE-answer.png": "l/5n",
	"./NO-answer.png": "kjUJ",
	"./Star.png": "2mO7",
	"./again-button.png": "zOki",
	"./again.png": "nh0a",
	"./answerbg.png": "NhZh",
	"./anw_button.png": "RlGd",
	"./back-button.png": "8h5P",
	"./backhome.png": "Wqks",
	"./bg-all.png": "a02/",
	"./bg-game3.png": "Azj5",
	"./bg-gerenchengji.png": "k0ps",
	"./bg-longhubang.png": "rgnf",
	"./bg1.png": "yfdd",
	"./bg2.png": "CjTQ",
	"./bg3.png": "VTmb",
	"./button-pause.png": "YnMF",
	"./certain-button.png": "qzp5",
	"./close-tipbutton.png": "waP3",
	"./closer.png": "iQdV",
	"./continue.png": "nh/b",
	"./file.png": "g1gp",
	"./gerenchengji-chengji.png": "HXbH",
	"./grade-button.png": "WRqx",
	"./grade-chengji.png": "H1yV",
	"./home.png": "KSZv",
	"./login-button.png": "K7B3",
	"./longhubang-chengji.png": "9xLd",
	"./network.png": "qLSx",
	"./new.png": "X10k",
	"./next-game.png": "ALXz",
	"./next-game3.png": "wuvb",
	"./next.png": "3aVt",
	"./no.png": "nP1P",
	"./pause-button.png": "67f+",
	"./practice.png": "K11G",
	"./question.png": "apGm",
	"./read-done.png": "nkQ7",
	"./select-answer.png": "9+Ru",
	"./select.png": "GEq8",
	"./select6.png": "nbv8",
	"./star-button.png": "jUl5",
	"./start-again.png": "GqsR",
	"./start-button.png": "Xyss",
	"./submit.png": "tUGb",
	"./time.png": "L7xM",
	"./tip-bg.png": "lXI2",
	"./tip-button.png": "YzX3",
	"./tip.png": "GH0F",
	"./title-homepage.png": "g3of",
	"./topbar-1.png": "J8Rj",
	"./topbar-2.png": "/L6c",
	"./topbar-3.png": "iccS",
	"./topbar-4.png": "i1V6",
	"./topbar-5.png": "sTNW",
	"./topbar-6.png": "wpSd",
	"./topbar-again.png": "+HXD",
	"./topbar-all.png": "6qjx",
	"./topbar-file.png": "Oc35",
	"./topbar-gerenchengji.png": "spv7",
	"./topbar-longhubang.png": "hpzz",
	"./topbar.png": "JTEy",
	"./topbg-chengji.png": "SAlu",
	"./wrong.png": "GWzh",
	"./yes-answer.png": "rvBl",
	"./yes.png": "aElj"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "tsha";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\.png$
// module id = tsha
// module chunks = 0